<script>
  export let color = 'white';
  export let direction = 'right';
  export let width = '7';
  export let height = '10';
</script>

<svg
  class="chevron {direction}"
  {width}
  {height}
  viewBox="0 0 7 10"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.5 1L5.5 5L1.5 9"
    stroke={color}
    style="stroke: var(--svg-stroke, {color});"
    stroke-width="1.5"
  />
</svg>

<style>
  .chevron {
    transform: scale(1.2);
  }

  .chevron.left {
    transform: rotate(180deg) scale(1.2);
  }

  .chevron.up {
    transform: rotate(-90deg) scale(1.2);
  }

  .chevron.down {
    transform: rotate(90deg) scale(1.2);
  }
</style>
